import { call, select } from "redux-saga/effects";

import {
  getPaymentIDList,
  getPaymentByID,
  isPaymentOutOfPlaces
} from "state/school_money/selectors";

import BasketItemIssue from "state/school_money/entities/BasketItemIssue";

/**
 * Check for issues with the given basket item.
 * Returns zero or one issues.
 *
 * @param {BasketItem} basketItem
 * @returns {BasketItemIssue | undefined}
 */
export default function* validateBasketItem(basketItem) {
  
  const { paymentID, installmentNumber } = basketItem.payload.toObject();

  if (yield call(isExpired, paymentID, installmentNumber)) {
    return BasketItemIssue.fromBasketItem(basketItem, "expired");
  }
  
  if (yield call(isLimitedPlacesFull, paymentID)) {
    return BasketItemIssue.fromBasketItem(basketItem, "limited_places");
  }

}

/**
 * Has the payment or installment disappeared from state?
 * @returns {boolean}
 */
function* isExpired(paymentID, installmentNumber) {
  const paymentIDList = yield select(getPaymentIDList);
  if (!paymentIDList.includes(paymentID)) {
    return true;
  }
  const payment = yield select(getPaymentByID, paymentID);
  return !payment.installments.has(installmentNumber);
}

/**
 * Have the limited places on this payment been filled?
 * @returns {boolean}
 */
function* isLimitedPlacesFull(paymentID) {
  return yield select(isPaymentOutOfPlaces, paymentID);
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/basketSaga/payment/validateBasketItem.js